import type { ComponentType } from 'react';
import type { ShellLinkProps } from './DashboardShell';

type NavLinkComponent = ComponentType<{
  to: string;
  end?: boolean;
  onClick?: () => void;
  style?: ShellLinkProps['style'];
  children: ShellLinkProps['children'];
}>;

/**
 * Adapts a router `NavLink` to {@link ShellLinkProps} so `DashboardShell` stays
 * router-agnostic. Apps pass their own `NavLink` to keep a single router instance.
 */
export function createShellNavLink(NavLink: NavLinkComponent) {
  return function ShellNavLink({ to, end, children, style, onClick }: ShellLinkProps) {
    return (
      <NavLink to={to} end={end} onClick={onClick} style={style}>
        {typeof children === 'function'
          ? ({ isActive }: { isActive: boolean }) => children({ isActive })
          : children}
      </NavLink>
    );
  };
}
